module.exports = function (number) {
    let validator = /^[\(1 -]*([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return validator.test(number);
};
